const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_bxqzrPLwY',
  aws_user_pools_web_client_id: 'j3lbarh186vl98vqsrmpe49fq',
  aws_appsync_dangerously_connect_to_http_endpoint_for_testing: false,
};

export default awsmobile;
